import React from 'react'
import {NavLink} from 'react-router-dom'
import { connect } from 'react-redux'
import { signOut } from '../../store/actions/authActions'
import "./navbar.css"
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignInAlt,
  faComments,
  faUserCircle,
  faHandPointRight,
  faCommentDots,
  faChalkboard,
  faDice,
  faGamepad,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faSignInAlt,
  faComments,
  faUserCircle,
  faHandPointRight,
  faCommentDots,
  faChalkboard,
  faDice,
  faGamepad
);

const SignedInLinks = (props) => {
    return (
        <ul className="right ttright">
            <li><NavLink to='/study' className="nav-text">บทเรียน <FontAwesomeIcon icon="chalkboard" /></NavLink></li>
            <li><NavLink to='/test' className="nav-text">แบบทดสอบ <FontAwesomeIcon icon="dice" /></NavLink></li>
            <li><NavLink to='/minigame' className="nav-text">มินิเกมส์ <FontAwesomeIcon icon="gamepad" /></NavLink></li>
            <li><NavLink to='/create' className="nav-text">Question box <FontAwesomeIcon icon="comments" /></NavLink></li>
            <li><a onClick={props.signOut} className="nav-text">Log out <FontAwesomeIcon icon="sign-in-alt" /></a></li>
            <li><NavLink to='/' className='btn btn-floating orange lighten-1'>
            {props.profile.initials}
            </NavLink></li>
        </ul>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        signOut: () => dispatch(signOut())
    }
}

export default connect(null, mapDispatchToProps)(SignedInLinks)